import { MobiDocument } from './MobiDocument';
import { SupplementPointageDocument } from './SupplementPointageDocument';

export class Supplement extends MobiDocument {
    private _id: string;
    private _rev: string;
    private _deleted?: boolean; //permet de supprimer un document
    private isInoe: boolean;
    //permet de savoir si le pointage à était envoyer vers Inoe
    private checked: boolean;
    private factureEnAttente: boolean;
    private inscriptionId: number;
    private intitule: string;
    private isFacture: boolean;
    private modifieApresFacture: boolean;
    private nomEnfant: string;
    private ordreListeAttente: number;
    private pointageDate: string;
    private supplementId: number;
    private telephone: string;
    private tooltipNumFacture: string;
    private typePointage: string;
    private typeSupplement: string;
    private version: number;
    private typedoc: string;
    private username: string;
    private pdetail_id: number;

   
    public constructor(supp: any) {
        super();
        this._id = supp._id;
        this._rev = supp._rev;
        this.isInoe = supp.isInoe;
        this.checked = supp.checked;
        this.factureEnAttente = supp.factureEnAttente;
        this.inscriptionId = supp.inscriptionId;
        this.intitule = supp.intitule;
        this.isFacture = supp.isFacture;
        this.modifieApresFacture = supp.modifieApresFacture;
        this.nomEnfant = supp.nomEnfant;
        this.ordreListeAttente = supp.ordreListeAttente;
        this.pointageDate = supp.pointageDate;
        this.supplementId = supp.supplementId;
        this.telephone = supp.telephone;
        this.tooltipNumFacture = supp.tooltipNumFacture;
        this.typePointage = supp.typePointage;
        this.typeSupplement = supp.typePointage;
        this.version = supp.version;
        this.typedoc = "supplementANMobi"
        this.username = supp.username,
        (typeof supp.pdetail_id !== "undefined")
            ? this.pdetail_id = supp.pdetail_id
            : this.pdetail_id = -1;
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public is_deleted(): boolean | undefined {
        return this._deleted;
    }

    public set_deleted(_deleted: boolean): void {
        this._deleted = _deleted;
    }

    public isIsInoe(): boolean {
        return this.isInoe;
    }

    public setIsInoe(isInoe: boolean): void {
        this.isInoe = isInoe;
    }

    public isChecked(): boolean {
        return this.checked;
    }

    public setChecked(checked: boolean): void {
        this.checked = checked;
    }

    public isFactureEnAttente(): boolean {
        return this.factureEnAttente;
    }

    public setFactureEnAttente(factureEnAttente: boolean): void {
        this.factureEnAttente = factureEnAttente;
    }

    public getInscriptionId(): number {
        return this.inscriptionId;
    }

    public setInscriptionId(inscriptionId: number): void {
        this.inscriptionId = inscriptionId;
    }

    public getIntitule(): string {
        return this.intitule;
    }

    public setIntitule(intitule: string): void {
        this.intitule = intitule;
    }

    public isIsFacture(): boolean {
        return this.isFacture;
    }

    public setIsFacture(isFacture: boolean): void {
        this.isFacture = isFacture;
    }

    public isModifieApresFacture(): boolean {
        return this.modifieApresFacture;
    }

    public setModifieApresFacture(modifieApresFacture: boolean): void {
        this.modifieApresFacture = modifieApresFacture;
    }

    public getNomEnfant(): string {
        return this.nomEnfant;
    }

    public setNomEnfant(nomEnfant: string): void {
        this.nomEnfant = nomEnfant;
    }

    public getOrdreListeAttente(): number {
        return this.ordreListeAttente;
    }

    public setOrdreListeAttente(ordreListeAttente: number): void {
        this.ordreListeAttente = ordreListeAttente;
    }

    public getPointageDate(): string {
        return this.pointageDate;
    }

    public setPointageDate(pointageDate: string): void {
        this.pointageDate = pointageDate;
    }

    public getSupplementId(): number {
        return this.supplementId;
    }

    public setSupplementId(supplementId: number): void {
        this.supplementId = supplementId;
    }

    public getTelephone(): string {
        return this.telephone;
    }

    public setTelephone(telephone: string): void {
        this.telephone = telephone;
    }

    public getTooltipNumFacture(): string {
        return this.tooltipNumFacture;
    }

    public setTooltipNumFacture(tooltipNumFacture: string): void {
        this.tooltipNumFacture = tooltipNumFacture;
    }

    public getTypePointage(): string {
        return this.typePointage;
    }

    public setTypePointage(typePointage: string): void {
        this.typePointage = typePointage;
    }

    public getTypeSupplement(): string {
        return this.typeSupplement;
    }

    public setTypeSupplement(typeSupplement: string): void {
        this.typeSupplement = typeSupplement;
    } public getVersion(): number {
        return this.version;
    }

    public setVersion(version: number): void {
        this.version = version;
    }

    public getTypedoc(): string {
        return this.typedoc;
    }

    public setTypedoc(typedoc: string): void {
        this.typedoc = typedoc;
    }

    public getUsername(): string {
        return this.username;
    }

    public setUsername(username: string): void {
        this.username = username;
    }

    public getPdetail_id(): number {
        return this.pdetail_id;
    }

    public setPdetail_id(pdetail_id: number): void {
        this.pdetail_id = pdetail_id;
    }



}